import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CommentsService } from 'app/core/comments/comments.service';
import { catchError, map, of, switchMap } from 'rxjs';
import {
    CommentActions,
    GetCommentsFailure,
    GetCommentsSuccess,
    GetTransactionComments,
    GetTransactionCommentsWithdraw,
    GetWithdrawCommentsSuccess,
} from '../actions/comment.actions';
import { WithdrawCommentPayload } from '../models/withdraw-comment.model';

@Injectable()
export class CommentEffects {
    constructor(
        private actions$: Actions,
        private commentService: CommentsService
    ) {}

    loadComments$ = createEffect(() =>
        this.actions$.pipe(
            ofType<GetTransactionComments>(
                CommentActions.GetTransactionComments
            ),
            switchMap((action) => {
                return this.commentService.getAllComments(action.payload).pipe(
                    map((data) => new GetCommentsSuccess(data)),
                    catchError((error) => of(new GetCommentsFailure(error)))
                );
            })
        )
    );

    loadWithdrawComments$ = createEffect(() =>
        this.actions$.pipe(
            ofType<GetTransactionCommentsWithdraw>(
                CommentActions.GetTransactionCommentsWithdraw
            ),
            switchMap((action) => {
                return this.commentService
                    .getAllWithdrawCommentsByTransactionId(
                        action.payload.transactionId
                    )
                    .pipe(
                        map(
                            (data: WithdrawCommentPayload) =>
                                new GetWithdrawCommentsSuccess(data)
                        ),
                        catchError((error) => {
                            console.error(error);
                            return of(error);
                        })
                    );
            })
        )
    );
}
